<template>
    <div class="link-justify-item">
        <slot></slot>
    </div>
</template>

<script>
    /**
     * @name：两端对齐父子组件子组件
     * @createdby：WangYue
     * @date：2018/11/26
     * @include：
     * @props：
     * @hooks：
     * @example：
     */

    export default {
        name: "link-justify-item"
    }
</script>

<style lang="scss">
    .link-justify-item{
        display: inline-block;
        box-sizing: border-box;
    }
</style>
